import { useCallback } from 'react';

import type { ActionTemplate } from 'config/api/actionLibrary/actionLibrary.types';
import ROLES from 'config/constants/ROLES';
import userDataStorage from 'storages/userDataStorage';

const useCanEditActionTemplate = () => {
  // @ts-ignore
  const userData = userDataStorage.get() || {};
  const { ps_roles = [] } = userData;

  const isContentEditor = ps_roles.includes(ROLES.PS_ROLES.CONTENT_EDITOR);

  const canEdit = useCallback(
    (template: ActionTemplate) => {
      if (!template) return false;

      // Content Editors can edit any template (including PocketSafe ones)
      if (isContentEditor) return true;

      // If not Content Editor, cannot edit PocketSafe templates
      if (template.ownerType === 'pocketsafe') return false;

      // Default to true for other cases (e.g. org templates)
      return true;
    },
    [isContentEditor],
  );

  return canEdit;
};

export default useCanEditActionTemplate;
